import React from "react";
import styled from "styled-components";

const List = () => {
  return (
    <PageList>
      <li>
        <a href="#about">About</a>
      </li>
      <li>
        <a href="#projects">Projects</a>
      </li>
      <li>
        <a href="#contact">Contact</a>
      </li>
    </PageList>
  );
};

export default List;

const PageList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-basis: 60%;
  color: #030303;
  list-style-type: none;
  li {
    text-decoration: none;
    a {
      color: #1f2858;
      &:hover {
        color: #1dacd6;
      }

      text-decoration: none;
    }
  }
  @media only screen and (max-width: 685px) {
    flex-direction: column;
    height: 45%;
    width: 100%;
  }
`;
